import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpClient) { }

  sendEmail(data, emailAccount: string): Observable<any> {
    return this.http.post<any>(environment.email_api + 'mails/' + emailAccount, data);
  }

  sendEmailBookingService(data) {
    return this.http.post<any>("https://gw.faircloudpms.com/bookingengine/client/send_email", data);
  }
}
